import { createStore } from "vuex";


export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isLoading: false,
    progress: 0,
    layout: "default",
    user:{
      id: 0,
      info:{},
      userName: "",
      isBemvindo: true,/* mudar pra false  */
      isAuthenticated: false,/* mudar pra false  */
      isGuest: false,
      userRole: "",
      access_token: "",
      refresh_token:""

  },
  },
  mutations: {
    setLoading(state, status) {
      state.isLoading = status;
    },
    setProgress(state, status) {
      state.progress = status;
    },
    setProgressTimer(state, status) {
      state.progress = status;
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show?.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show?.classList.add("g-sidenav-hidden");
        sidenav_show?.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    }
  },
  getters: {}
});
